var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",style:(_vm.config.textStyle ? _vm.config.textStyle : {})},[_vm._v("\n  "+_vm._s(_vm.itemData)+"\n  "),_c('span',{style:(_vm.config.spanStyle)},[_vm._v(_vm._s(_vm.config.tips))])])}
var staticRenderFns = []

export { render, staticRenderFns }